<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Helpers
	import { convert, capFirstChar } from '../../helpers/utilities';
	import { load_image_from } from '../../helpers/interface_helpers';
	import {
		deriveRoomName,
		HiddenDevicesRoomID,
		HiddenRoomObject,
	} from '../../helpers/service_rooms_helpers';
	//Stores
	import { devices } from 'src/stores/lists/devices';
import { rooms } from 'src/stores/lists/rooms';
	import {
		// consumption_rooms,
		consumption_device,
	} from 'src/stores/features/consumption';
	import { navigateToDevice } from 'src/stores/ui/navigate-to';
	//Design system components
	import { Text, Stack, ListItem, ListMenuCard } from '@Shelly/shelly-design-system';
	//App Components
	import NotificationList from '../Lists/NotificationList.svelte';
	import RoomLabelMain from '../Lists/Rooms/RoomLabelMain.svelte';
	import RoomLabelList from '../Lists/Rooms/RoomLabelList.svelte';
	import RoomTempDrawerPreview from '../TemperatureScheme/TempSchemeDrawSections/RoomTempDrawerPreview.svelte';
	//Types
	import type { Device } from '../../types/Device';
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';

	const id = $sidePanelStateCombined?.id;
	const units = 'W';
	const defaultToShow = 5;
	let showAllDevices = false;

	// $: includedPowerTotal = consumption_add_total($consumption_rooms, 'in_power');
	// $: excludedPowerTotal = consumption_add_total($consumption_rooms, 'ex_power');

	// $: totalConsumption = convert(
	// 	$consumption_rooms[id]?.in_power + $consumption_rooms[id].ex_power,
	// 	units
	// );

	$: allRooms = { ...$rooms, [HiddenDevicesRoomID]: HiddenRoomObject };

	$: image = allRooms[id]?.image ? load_image_from(allRooms[id]?.image) : undefined;
	$: backgroundColor = allRooms[id]?.backgroundColor;

	$: consumingDevices = Object.keys($consumption_device)
		.filter((devID) => $devices?.[devID]?.room_id == +id)
		.map((devID) => {
			if (!$devices?.[devID]) {
				return {};
			}
			const { image, name } = $devices[devID];
			return { ...$consumption_device[devID], image, name, devID };
		})
		.filter((d) => {
			// filterd devices with consumption
			return d._power !== 0;
		})
		.sort((a, b) => {
			// order devices by consumption
			return b._power - a._power;
		});

	$: hideShowMoreItem = consumingDevices.length - defaultToShow <= 0;
	$: devicesToRender = showAllDevices ? consumingDevices : consumingDevices.slice(0, defaultToShow);

	let devicesInRoom = [];

	$: {
		Object.values($devices)
			.filter((d: Device) => {
				devicesInRoom = [];
				return d.room_id == Number(id);
			})
			.map((d: Device) => {
				devicesInRoom.push(d.id);
			});
	}
</script>

<ListMenuCard
	size="medium"
	title={deriveRoomName(id)}
	{image}
	{backgroundColor}
	class="pointer-events-none mb-m"
>
	<RoomLabelMain item={allRooms[id]} slot="titleRight" />

	<RoomLabelList item={allRooms[id]} size="m" slot="main" />
</ListMenuCard>

<RoomTempDrawerPreview class="mb-m" {id} />

<Text element="h2" class="mb-s">
	{capFirstChar(
		$format('title_actively_consuming', {
			default: 'Actively Consuming Devices',
		}),
	)} ({consumingDevices.length})
</Text>

{#if consumingDevices.length > 0}
	<Stack gap="xs" class="mb-m">
		{#each devicesToRender as { devID, name, image, in_power, _power }}
			<ListItem
				image={load_image_from(image, $devices?.[devID]?.server)}
				title={name}
				progress={{
					title: convert(_power, units),
					color: in_power !== 0 ? 'solar' : 'warning',
				}}
				viewType="default"
				actionBtn
				on:click={() => {
					navigateToDevice(devID);
				}}
			/>
		{/each}

		{#if !hideShowMoreItem && !showAllDevices}
			<ListItem
				viewType="more"
				title={`+${consumingDevices.length - defaultToShow} more`}
				on:click={() => {
					showAllDevices = true;
				}}
			/>
		{/if}
	</Stack>
{:else}
	<Text class="mb-m" styleType="body-small">
		{$format('energy_consuming_devices_descr', {
			default: 'When devices consume energy, you will see them listed here',
		})}</Text
	>
{/if}

<NotificationList devicesFilter={devicesInRoom} />

<!-- <ControlsContainer color="color-base"> -->
<!-- <svelte:fragment slot="first">
		<DoubleDeviceButton size="l" isActive={false}>
			<DeviceButton
				size="l"
				slot="buttonLeft"
				icon="fas fa-minus"
				variant="primary"
			/>
			<svelte:fragment slot="content">
				<Text styleType="body-small" class="text-bold">212</Text>
				<Text styleType="body-small">°F</Text>
			</svelte:fragment>
			<DeviceButton
				size="l"
				slot="buttonRight"
				icon="fas fa-plus"
				variant="danger"
			/>
		</DoubleDeviceButton>
		<Text styleType="controls-large" class="mt-s text-bold">Cooling</Text>
	</svelte:fragment> -->
<!-- {#if roomThermostat}
		<ControlTrv></ControlTrv>
	{/if} -->
<!-- </ControlsContainer> -->
